import { useEffect } from 'react';

export const useBeforeUnloadListener = (alertMessage: string) => {
  useEffect(() => {
    const eventListener = (event: BeforeUnloadEvent) => {
      // Cancel the event as stated by the standard.
      event.preventDefault();
      // Chrome requires returnValue to be set.
      event.returnValue = alertMessage;
    };

    window.addEventListener('beforeunload', eventListener);
    return () => {
      window.removeEventListener('beforeunload', eventListener);
    };
  }, [alertMessage]);
};
